import { library } from '@fortawesome/fontawesome-svg-core'; 

//Import các icon mà bạn muốn sử dụng trong từng gói
import { faCode, faHighlighter, faBed, faPlane, faCar, faTaxi, faCalendar, faFemale, faLocationDot } from '@fortawesome/free-solid-svg-icons';  

//Add các icon đã được import vào trong thư viện của bạn
library.add(  faCode, faHighlighter,faBed, faPlane, faCar, faTaxi, faCalendar, faFemale, faLocationDot )